import { render, staticRenderFns } from "./Points_Filter.vue?vue&type=template&id=f9a5397a&scoped=true&"
import script from "./Points_Filter.vue?vue&type=script&lang=js&"
export * from "./Points_Filter.vue?vue&type=script&lang=js&"
import style0 from "./Points_Filter.vue?vue&type=style&index=0&id=f9a5397a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a5397a",
  null
  
)

export default component.exports